export default "__VITE_ASSET__y5njorDv__"